import CustomZObject from './CustomZObject.js';

export default class ZButtonPresser extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.newOutlet("on pressed");
        this.newOutlet("on released");
    }
}
